import { css } from '@linaria/core';
import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { SubHeadline, Title } from '~components/Typography';
import { GridCarouselItem } from '~shared/ui/organisms/GridCarousel/styles';
import { MqTablet } from '~theme/media';

export const Images = styled.div`
	position: relative;
	overflow: hidden;
	border-radius: var(--radius-xs);
	aspect-ratio: 0.72;
	touch-action: manipulation;
	transition: box-shadow 0.2s ease;
`;

export const Video = styled.video`
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const gridItemWrapperStyle = css`
	position: relative;
	z-index: 0;
	display: flex;
	flex-flow: column nowrap;
	border-radius: var(--radius-xs);
	user-select: none;
`;

export const Wrapper = styled(Link)`
	${gridItemWrapperStyle};
	padding-bottom: 2.8rem;
	border-radius: var(--radius-xs);
	background: var(--color-grey-10-solid);

	img {
		position: relative;
		z-index: -1;
		border-radius: var(--radius-xs);
	}
	&:hover ${GridCarouselItem} {
		box-shadow:
			-4.822px -4.822px 4.822px 0 rgba(255, 255, 255, 0.33) inset,
			4.822px 4.822px 4.822px 0 rgba(255, 255, 255, 0.25) inset;
	}
`;

export const Info = styled.div`
	position: relative;
	display: grid;
	flex-grow: 1;
	padding: 8px 8px 8px 12px;
	gap: var(--gap-s) 1px;
	grid-template-areas: 'title button' 'text button';
	grid-template-columns: minmax(0, 1fr) 32px;

	${MqTablet} {
		gap: var(--gap-s) var(--gap-s);
	}

	&:not(:has(> *:not(.skeleton):only-child)) {
		align-content: start;
	}
	& > *:not(.skeleton):only-child {
		span {
			font-size: var(--font-size-m);
		}
		padding: 8px 16px;
		grid-area: 1 / 1 / 3 / 3;
		place-self: center;
	}
`;

export const Tags = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-flow: row wrap;
	padding: 7px 8px 0;
	&:empty {
		display: none;
	}
`;

export const Tag = styled(SubHeadline)`
	display: flex;
	align-items: center;
	justify-content: center;
	filter: drop-shadow(0 0 3px var(--color-black-solid));
	svg {
		width: 17px;
		height: 17px;
		margin-right: 5px;
	}
	&:not(:last-child) {
		position: relative;
		margin-right: 10px;
		&::after {
			position: absolute;
			top: 48%;
			right: -7px;
			display: block;
			width: 3px;
			height: 3px;
			border-radius: 100%;
			background: var(--color-white-solid);
			content: '';
		}
	}
`;

export const Footer = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	overflow: hidden;

	max-width: 100%;
	padding: 0 0.8rem 1.2rem 1.2rem;
	user-select: none;

	svg {
		width: 17px;
		height: 17px;
		margin-right: 5px;
	}
`;

export const StyledTitle = styled(Title)`
	position: absolute;
	bottom: 21px;
	width: 100%;
	padding: 0 12px;
	font-weight: var(--font-weight-semibold);
`;
